import { render, staticRenderFns } from "./assessments.vue?vue&type=template&id=0d80a006&scoped=true"
import script from "./assessments.vue?vue&type=script&lang=js"
export * from "./assessments.vue?vue&type=script&lang=js"
import style0 from "./assessments.vue?vue&type=style&index=0&id=0d80a006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d80a006",
  null
  
)

export default component.exports